<template>
  <div>
    <div v-if="loadStatus === 1" :style="bgColor" class="page">
      <!-- 页面内容 -->
      <div class="container">
        <component
          :is="comp"
          v-for="comp in compList"
          :key="comp"
          :page-config="pageConfig"
          :cfh-info="cfhInfo"
          :fund-type="fundType"
          :fund-code="fundCode"
          :basic-info="fundCore"
          :detail-info="detailData"
          :fund-name="fundCore.fundName"
        />
      </div>
      <!-- 小天 -->
      <smart-assistant :basic-info="fundCore" :detail-info="detailData" />
      <!-- 固底操作面板 -->
      <bottom-panel
        :fund-code="fundCode"
        :cfh-info="cfhInfo"
        :basic-info="fundCore"
        :detail-info="detailData"
      />
    </div>
    <div v-else>
      <img v-if="loadStatus === 0" :src="LOADING" class="loading" />
      <div v-else class="err-box">
        <img :src="ERR_IMG" class="err-img" />
        <div>暂无数据</div>
      </div>
    </div>
    <option-edit-group ref="optionEditGroup" />
    <group-list ref="groupList" />
  </div>
</template>

<script>
import ERR_IMG from '@/assets/NS-004.png';
import QuestionAndDiscuss from '@/components/Fund-BarAndQue.vue';
import PAGE_CONFIG from '@/configs/page-config';
import { setNavTitle } from '@/utils/nativeBridge';
import WapInterface from '@fund/wap-interface';
import Vue from 'vue';
import { mapMutations } from 'vuex';
import FundChartTab from '../../components/chart/FundChartTab.vue';
import CfhInfo from '../../components/common/CfhInfo.vue';
import ConfigAnnounce from '../../components/common/ConfigAnnounce.vue';
import HeaderVideo from '../../components/common/HeaderVideo.vue';
import BonusTip from './components/BonusTip.vue';
import GroupList from './components/BottomPanel/GroupList.vue';
import BottomPanel from './components/BottomPanel/index.vue';
import OptionEditGroup from './components/BottomPanel/OptionEditGroup.vue';
import CfhAnnounce from './components/CfhAnnounce.vue';
import EtfRelateFund from './components/EtfRelateFund.vue';
import FeatureData from './components/FeatureData.vue';
import FundArchives from './components/FundArchives/index.vue';
import FundBasicHeader from './components/FundBasicHeader.vue';
import FundBonus from './components/FundBonus.vue';
import FundHold from './components/FundHold/index.vue';
import FundPensionA from './components/FundPensionA.vue';
import FundWarnTips from './components/FundWarnTips.vue';
import FundMarketQuotation from './components/MarketQuotation/FundMarketQuotation.vue';
import NewFundBuyProgress from './components/NewFundBuyProgress.vue';
import NewFundRead from './components/NewFundRead.vue';
import NoticeAndNews from './components/NoticeAndNews.vue';
import OverseaTip from './components/OverseaTip.vue';
import PageFooter from './components/PageFooter.vue';
import RelatedIndex from './components/RelatedIndex.vue';
import SmartAssistant from './components/SmartAssistant.vue';
import TradeRule from './components/TradeRule.vue';

export default {
  name: 'fund-detail',

  components: {
    HeaderVideo,
    ConfigAnnounce,
    FundBasicHeader,
    FundPensionA,
    CfhInfo,
    RelatedIndex,
    CfhAnnounce,
    BonusTip,
    FundWarnTips,
    FundChartTab,
    FundMarketQuotation,
    FundArchives,
    FundHold,
    FundBonus,
    FeatureData,
    TradeRule,
    NoticeAndNews,
    QuestionAndDiscuss,
    PageFooter,
    BottomPanel,
    NewFundRead,
    NewFundBuyProgress,
    OverseaTip,
    EtfRelateFund,
    SmartAssistant,
    OptionEditGroup,
    GroupList,
  },

  props: {
    fundCode: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      pageType: '',
      fundType: '', // 基金类型
      fundCore: null, // 核心数据
      detailData: null, // 详情数据，来自聚合第一屏接口+第二屏接口
      cfhInfo: {}, // 财富号信息
      pageConfig: {}, // 页面配置信息
      loadStatus: 0, // 加载状态 0-加载中，1-加载完成，-1-加载失败
      LOADING: 'https://j5.dfcfw.com/sc/image/202006/20200622011833.gif',
      ERR_IMG,
    };
  },

  computed: {
    compList() {
      if (this.fundType === 'new-fund') {
        return PAGE_CONFIG?.newFund || [];
      }
      return PAGE_CONFIG?.detail || [];
    },
    bgColor() {
      return this.fundCore?.isDelListedFund
        ? {
          'background-image': 'linear-gradient(to bottom, #999999, #f5f5f5)',
        }
        : {
          'background-image': 'linear-gradient(#e93801,#f5f5f5 320px,#f5f5f5)',
        };
    },
  },

  async mounted() {
    Vue.prototype.$optionEditGroup = this.$refs.optionEditGroup;
    Vue.prototype.$groupList = this.$refs.groupList;
    // 取接口
    this.fundCore = await this.getFundCoreInfo();
    console.log('===> page mounted', this.fundCore);
    if (!this.$isEmpty(this.fundCore)) {
      window.sendTrackLog('Div', 'Show', 'xpzy.pzy.ympg.show', '');
      window.sendTrackLog('Div', 'Show', 'wxpzy.tb.jjmc.show', '');
      this.$wxSendTrack('wxpzy.tb.jjmc.show', 'Show', { infoCode: this.fundCode, infoCodeType: 5 });
      const oldFundType = this.configFundType(this.fundCore);
      this.loadStatus = 1;
      setNavTitle(this.fundCore.fundName ? this.fundCore.fundName : '天天基金');
      this.pageType = this.getPageType(this.fundCore, oldFundType);
      this.fundType = this.getFundType(this.fundCore);
      if (!this.fundCore?.isCache) {
        // 核心接口非缓存数据 - 请求详情数据
        this.getFundDetailInfo();
        this.getCfhReadInfo();
        this.getPageConfig();
        this.getStockOverseaInfo();
      }
      // 滚动事件监听
      window.addEventListener('touchmove', () => {
        // console.log('touchmove', e);
        // e.preventDefault(); // 阻止默认行为
        // e.stopPropagation(); // 阻止冒泡
      });
    } else {
      // 无数据
      this.loadStatus = -1;
    }
    // 顶部与悬浮窗
    const wapInterface = new WapInterface({
      topBanner: {
        isShow: true,
        bulletinUrl:
          'https://fundsso.eastmoney.com/FundWapModule/requestconvert.ashx?url=http://bulletin.eastmoney.com/html/Image/411.html',
      },
      openApp: {
        isShow: true,
        bottom: 80,
        text: '打开天天基金',
        linkTo: `fund://mp.1234567.com.cn/weex/fundb5035dd2ee584a/pages/fund-detail-public/index?currentCode=${this.fundCode}`,
        isVerifyLogin: false,
      },
      bottomMap: {
        isShow: false,
      },
    });
    wapInterface.init();
  },

  methods: {
    ...mapMutations('detail1', ['setFundDetail1']),
    ...mapMutations('overseaInfo', ['setOversea', 'setOverseaInfo']),
    // 获取基金核心数据
    async getFundCoreInfo() {
      if (!this.fundCode?.length) return {};
      let fundCacheRes = {};
      const detailRes = await this.$http
        .useRequests('FundComApi.getPublicOfferCoreData', { FCODES: this.fundCode })
        .catch((err) => {
          console.log('====> getPublicOfferCoreData ERR', err);
          fundCacheRes = JSON.parse(localStorage.getItem(`ttjj-fund-${this.fundCode}`)) || {};
          this.$feedback.showToast({ title: '网络不给力，请检查网络设置' });
        });
      if (this.$isEmpty(detailRes)) return { ...fundCacheRes, isCache: true };
      localStorage.setItem(`ttjj-fund-${this.fundCode}`, JSON.stringify(detailRes));
      return detailRes;
    },

    // 页面类型
    getPageType(fundInfo = {}, fundType) {
      console.log('---> fundType', fundType);
      if (fundType === 'GDLC') return 'HighEnd';
      if (fundType === 'HKFund') return 'HK';
      if (fundInfo?.isNewFund) return 'DetailPage';
      if (fundInfo?.isETF) return 'DetailPage';
      if (fundInfo?.isCurrencyFund) return 'DetailPage';
      return 'DetailPage';
    },

    // 获取基金类型
    getFundType(fundInfo = {}) {
      if (fundInfo?.isNewFund) return 'new-fund';
      if (fundInfo?.isETF) return 'ETF';
      if (fundInfo?.isCurrencyFund) return 'currency';
      return 'detail';
    },

    // 获取基金详情数据
    getFundDetailInfo() {
      if (!this.fundCode?.length) return;
      Promise.all([
        this.$http.useRequests('FundDgs.getDetailPage1', { fcode: this.fundCode }),
        this.$http.useRequests('FundDgs.getDetailPage2', { fcode: this.fundCode }),
      ])
        .then(([res1, res2]) => {
          console.log('===> get fund detail', res1, res2);
          this.detailData = { ...res1, ...res2 };
          this.setFundDetail1(res1);
        })
        .catch((err) => {
          console.log('===> getFundDetail ERR', err);
        });
    },

    // 获取财富号数据
    getCfhReadInfo() {
      if (!this.fundCode?.length) return;
      const curTime = new Date().getTime();
      const infoCache = JSON.parse(localStorage.getItem(`ttjj-fund-cfh-${this.fundCode}`)) || {};
      const lastTime = infoCache?.lastTime || 0;
      if (
        curTime - parseInt(lastTime, 10) > 3 * 60 * 60 * 1000 // 缓存过期
        || this.$isEmpty(infoCache)
      ) {
        this.$http
          .useRequests('CFHApi.getReadByFund', this.fundCode)
          .then((res) => {
            console.log('===> cfhRes', res);
            localStorage.setItem(
              `ttjj-fund-cfh-${this.fundCode}`,
              JSON.stringify({
                ...res,
                lastTime: curTime,
              }),
            );
            this.cfhInfo = res;
          })
          .catch((err) => {
            console.log('getCfhReadInfo ERR', err);
            this.cfhInfo = infoCache;
          });
        return;
      }
      this.cfhInfo = infoCache;
    },

    // 获取页面配置信息 - 缓存3小时
    getPageConfig() {
      if (!this.fundCode?.length) return;
      const curTime = new Date().getTime();
      const configCache = JSON.parse(localStorage.getItem(`ttjj-fund-config-${this.fundCode}`)) || {};
      const lastTime = configCache?.lastTime || 0;
      if (curTime - parseInt(lastTime, 10) > 3 * 60 * 60 * 1000 || this.$isEmpty(configCache)) {
        // 缓存过期
        this.$http
          .useRequests('ConfigApi.getFundPageConfigure', this.fundCode)
          .then((res) => {
            console.log('===> pageConfig', res);
            localStorage.setItem(
              `ttjj-fund-config-${this.fundCode}`,
              JSON.stringify({
                ...res,
                lastTime: curTime,
              }),
            );
            this.pageConfig = res;
          })
          .catch((err) => {
            console.log('getPageConfig ERR', err);
            this.pageConfig = configCache;
          });
        return;
      }
      this.pageConfig = configCache;
    },

    // 获取基金海外行情数据
    getStockOverseaInfo() {
      if (!this.fundCode?.length) return;
      this.$http
        .useRequests('EMHqApi.getStockOversea', this.fundCode)
        .then((res) => {
          // 设置海外ip
          if (res?.lt && (res?.lt).toString() === '2') {
            this.setOversea(true);
            this.setOverseaInfo({
              delayText: '根据交易所监管要求，您所在的地区当前行情延迟15分钟展示',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 基金类型 - 老小程序品种页逻辑
    configFundType(fundCore) {
      let curType = 'PTFund';
      const {
        feature, pType, fundType, isExchg, isNewFund,
      } = fundCore;
      // 判断养老基金
      try {
        // ETF新发用ETF模板 所以要先判断ETF
        if (feature.indexOf('010') >= 0) {
          curType = 'CNFund';
        } else if (pType === 'H') {
          curType = 'HKFund';
        } else if (
          (fundType === '005' || fundType === '004')
          && (feature.indexOf('200') < 0 || feature === '--')
        ) {
          curType = 'CurrencyFund';
        } else if (fundType === '100' || parseInt(isExchg, 10) - 0 === 1) {
          curType = 'CNFund';
        } else if (isNewFund) {
          curType = pType === 'G' ? 'GDLC' : 'NewFund';
        } else if (pType === 'G') {
          curType = 'GDLC';
        } else {
          curType = 'PTFund';
        }
      } catch (error) {
        curType = 'PTFund';
        console.log(error);
      }
      return curType;
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  background-image: linear-gradient(#e93801, #f5f5f5 320px, #f5f5f5);
  width: 100%;
  min-height: 750px;
  box-sizing: border-box;

  .container {
    width: 100%;
    padding: 24px 24px 0;
    box-sizing: border-box;
  }
}

.loading {
  height: 100px;
  width: 440px;
  margin-top: calc(50% - 50px);
  margin-left: calc(50% - 220px);
}

.err-box {
  margin-top: calc(50% - 226px);
  font-size: 30px;
  color: #999999;
  text-align: center;

  .err-img {
    height: 400px;
  }
}
</style>
